module.exports = __webpack_public_path__ + "static/wholesale-5fa441e46326bc79b197631e55496696.png";